
import { Component, Prop, Vue } from 'vue-property-decorator'
import LayoutMenu from './MainLayoutMenu.vue'
import LayoutUser from './MainLayoutUser.vue'
import Notification from './notify/Notification.vue'
import { SysMenuOutput as MenuTree } from '@/api/swagger'

@Component({
  name: 'MainLayoutHeader',
  components: { LayoutMenu, LayoutUser, Notification },
})
export default class MainLayoutHeader extends Vue {
  @Prop({ type: String, default: 'light' })
  private theme!: 'light' | 'dark'

  @Prop({ type: Array, default: null })
  private menus!: MenuTree[]
}
